<template lang="pug">
  v-form.px-sm-0.px-md-10.pb-0.pb-sm-2.pb-md-4
    v-container(fluid)
      v-row 
        v-col(cols="12")
          v-stepper.pb-2.my-2(v-model="form.stepVisible" vertical)
            v-stepper-step.pl-2.pl-sm-6(:complete="form.stepVisible > 1" step="1", :editable="form.step1.editable") {{translations.selectClient}}
            v-stepper-content.ml-5.ml-sm-9(step="1")
              ValidationObserver(v-slot="{ invalid, handleSubmit }" ref="validator1")
                form(@submit.prevent="handleSubmit(onSubmitStep1)")
                  ValidationProvider(rules="required" v-slot="{ errors }")
                    v-select(@change="clearSelect", :items="form.step1.invoiceClients.item" v-model="form.step1.invoiceClients.value")
                      template(v-slot:label)
                        v-icon.pr-1(color="red accent-2" size="12") mdi-asterisk
                        | {{translations.customer}}
                  v-btn.float-right.big(color="primary" type="submit", :disabled="invalid") {{translations.nextButton}}

            v-stepper-step.pl-2.pl-sm-6(:complete="form.stepVisible > 2" step="2", :editable="form.step2.editable") {{translations.title.create}}
            v-stepper-content.ml-5.ml-sm-9(step="2")
              ValidationObserver(v-slot="{ invalid, handleSubmit }" ref="validator2")
                form(@submit.prevent="handleSubmit(onSubmitStep2)")
                  v-container(fluid)
                    section
                      v-row.px-10
                        v-col(cols="12")
                          v-row
                            v-col(cols="12" md="6" sm="12")
                              h2.title.is-3 To
                              ValidationProvider(v-if="form.step1.invoiceClients.value === '1'" rules="required" v-slot="{ errors }")
                                v-select(@change="setInvoiceTo" v-model="form.step2.client", :items="providersListAll")
                                  template(v-slot:label)
                                    v-icon.pr-1(color="red accent-2" size="12") mdi-asterisk
                                    | {{translations.provider}}
                                span.red--text.text--accent-2(v-if="errors.length > 0")
                                  v-icon(color="red accent-2") mdi-alert
                                  |  {{ errors[0] }}
                              ValidationProvider(rules="required" v-if="form.step1.invoiceClients.value === '2'" v-slot="{ errors }")
                                v-select(:items="operatorsListAll" @change="setInvoiceTo" v-model="form.step2.client")
                                  template(v-slot:label)
                                    v-icon.pr-1(color="red accent-2" size="12") mdi-asterisk
                                    | {{translations.operator}}
                                span.red--text.text--accent-2(v-if="errors.length > 0")
                                  v-icon(color="red accent-2") mdi-alert
                                  |  {{ errors[0] }}
                            v-col(cols="12" md="6" sm="12")
                              h2.title.is-3 {{translations.form.invoiceDetails}}
                              //- Invoice #
                              BaseTextField(:label='translations.form.invoiceID', type='text' rules="required" v-model='invoice_id', )
                        //- v-col(cols="12")
                        //-   datepicker#invoiceDate(input-class='input input--datepicker', :format='formatDate', label='invoiceDate', placeholder='01/05/18', v-model='invoice_date', ref='invoiceDate')
                        //- v-col(cols="12")
                        //-   datepicker#invoiceDue(input-class='input input--datepicker', :format='formatDate', label='invoiceDue', placeholder='01/06/18', v-model='invoice_due', ref='invoiceDue')
                        v-col(cols="12")
                          v-row
                            v-col(cols="12")
                              h2.title.is-3 {{translations.form.items}}
                              BaseInvoiceItemsField(v-model="items")
                          v-row.justify-end
                            v-col(cols="12" md="2").text-right
                              p {{translations.form.discount}}
                            v-col(cols="12" md="2")
                              span {{ itemsDiscountTotal | money }}
                          v-row.justify-end
                            v-col(cols="12" md="2").text-right
                              p {{translations.form.tax}}
                            v-col(cols="12" md="2")
                              span {{ itemsTaxTotal | money }}
                          v-row.justify-end
                            v-col(cols="12" md="2").text-right
                              p {{translations.label.total}}
                            v-col(cols="12" md="2")
                              span {{ itemsTotal | money }}
                          v-col(cols="4" md="3" sm="1")
                          v-col(cols="4" md="4" sm="5")
                            h2.title.is-3 {{translations.form.invoiceNotes}}
                            v-textarea( :placeholder='translations.form.invoiceNotes', v-model='invoice_notes')
                          v-col(cols="12")
                            v-btn.float-right.button.is-medium.is-info(color="primary" type="submit", :disabled="invalid" @click='submitDataForm') {{translations.form.generateInvoice}}
                //-GENERATED INVOICE
            v-stepper-step.pl-2.pl-sm-6(:complete="form.stepVisible > 3" step="3", :editable="form.step3.editable") {{translations.form.viewInvoiceTitle}}
            v-stepper-content.ml-5.ml-sm-9(step="3")
              section.section(v-if='generateInvoice', key='generateInvoice' ref="content").mt-5
                v-container.finance__invoice(id="invoice" )
                  v-row
                    v-col(cols="9")
                      h1 {{translations.form.invoice}}
                    v-col(cols="3")
                      p
                        strong {{translations.form.invoiceID}}:
                        |  {{ invoice_id }}
                      p(v-if='invoice_date')
                        strong {{translations.form.invoiceDate}}:
                        |  {{ formatDate(invoice_date) }}
                      p(v-if='invoice_due')
                        strong {{translations.form.invoiceDue}}:
                        |  {{ formatDate(invoice_due) }}
                      p
                        strong {{translations.form.invoiceAmountDue}}:
                        |  {{ itemsTotal | money }}
                  v-row
                    v-col(cols="6")
                      address
                        strong {{ businessName }}
                        p {{ from_address1 }}
                        p(v-if="from_address2 != ''") {{ from_address2 }}
                        p {{ from_postcode }}  {{ from_city }}
                    v-col(cols="6").text-right
                      address
                        strong {{ clientName }}
                        p {{ client_address }}
                        p {{ client_email }} {{ client_phone }}
                        p {{client_vat}}
                  v-row
                    v-col
                      v-simple-table.invoice__table.table.is-striped.is-fullwidth
                        thead.has-background-primary
                          tr
                            th.has-text-white-bis.has-text-left {{translations.label.no}}
                            th.has-text-white-bis.has-text-left {{translations.label.description}}
                            th.has-text-white-bis.has-text-right {{translations.label.qty}}
                            th.has-text-white-bis.has-text-right {{translations.label.price}}
                            th.has-text-white-bis.has-text-right {{translations.label.discount}}
                            th.has-text-white-bis.has-text-right {{translations.label.tax}}
                            th.has-text-white-bis.has-text-right {{translations.label.total}}
                        tbody
                          tr(v-for='(item, index) in items', :key='index')
                            td
                              | {{ index +1 }}
                            td
                              | {{ item.description }}
                            td.has-text-right
                              | {{ item.qty }}
                            td.has-text-right
                              | {{ item.price }}
                            td.has-text-right
                              | {{ item.discount }}
                            td.has-text-right
                              | {{ item.tax }}
                            td.has-text-right
                              | {{ item.total | money }}
                          tr
                            td(colspan='5')
                            td(colspan='1')
                              | {{translations.form.discount}}
                            td.has-text-right(colspan='1')
                              | {{ itemsDiscountTotal | money }}
                          tr
                            td(colspan='5')
                            td(colspan='1')
                              | {{translations.form.tax}}
                            td.has-text-right(colspan='1')
                              | {{ itemsTaxTotal | money }}
                          tr
                            td(colspan='5')
                            td(colspan='1')
                              | {{translations.label.total}}
                            td(colspan='1')
                              | {{ itemsTotal | money }}
                  v-row.mt-10
                    v-col(cols="6")
                      v-card(color="primary").elevation-0.finance__paymentDetails__card
                        v-container.pt-5.finance__paymentDetails__card__header
                          | {{translations.form.paymentDetails}}
                        v-divider
                        v-container.finance__paymentDetails__card__details
                          p
                            | {{translations.form.paymentMethod}}
                          p
                            | {{translations.form.paymentExpiration}}
                          p
                            | {{translations.form.paymentAccountNumber}}:
                            | EN18 0081 1291 4100 0128 2333
                          p
                            | {{translations.form.paymentAdvice}}
                  v-row.my-5
                    v-col(cols="12")
                      v-btn.float-right(style='margin-top: 24px;'
                        color="primary"
                        @click='exportPDF'
                        :loading="loadingCreate") {{translations.form.downloadInvoice}}
</template>

<script>

  import html2pdf from 'html2pdf.js';
  const moment = require('moment');

  export default {
    name: "InvoiceCreate",
    props:{
      clearForm: {
        type: Boolean,
        default: false
      },
      translations: {
        type: Object,
        default: function(){
          return {}
        }
      },
      providersListAll: {
        type: Array,
        default: function(){
          return []
        }
      },
      operatorsListAll: {
        type: Array,
        default: function(){
          return []
        }
      },
    },
    data:() => ({
      e1: 1,
      businessName: 'Emara Play SL',
      from_address1: 'Paseo de las Palmeras 8a  Entreplanta',
      from_address2: '',
      from_city: 'Ceuta, Spain',
      from_postcode: '51001',
      from_vat: 'B51041267',
      clientName: '',
      client_address: '',
      client_email: '',
      client_phone: '',
      client_vat: '',
      tax: '',
      invoice_id: '',
      invoice_date: '',
      invoice_due: '',
      items: [],
      taxtotal: 0,
      total: 0,
      account_label: '',
      account_sortcode: '',
      account_number: '',
      invoice_notes: '',
      generateInvoice: false,
      form: {
        stepVisible: 1,
        step1: {
          editable: true,
          invoiceClients: {
            value: null,
            item: [
              {
                text: 'Provider',
                value: '1',
              },
              {
                text: 'Operator',
                value: '2',
              }
            ]
          }
        },
        step2: {
          editable: false,
          client: '',
        },
        step3: {
          editable: false,
        }
      },
      submitForm: {
        provider: '',
        bookmaker: '',
        accountManager: '',
        number: '',
        date: '',
        dueDate: '',
        paymentDate: '',
        items: [],
        notes: '',
        status: '',
      }
    }),
    computed: {
      loadingCreate() {
        return this.$store.state.statusCode.createPayout.loading;
      },
      stateCreate() {
        return this.$store.state.statusCode.createPayout.state;
      },
      itemsTotal() {
        return this.items.reduce((acc, item) => acc + item.total, 0);
      },
      itemsDiscountTotal() {
        return this.items.reduce((acc, item) => acc + item.discount_amount, 0);
      },
      itemsTaxTotal() {
        return this.items.reduce((acc, item) => acc + item.tax_amount, 0);
      },
    },
    watch: {
      clearForm: function(val){
        if (val){
          this.clearFields();
          this.$refs.validator1.reset();
          this.$refs.validator2.reset();
        }
      },
      stateCreate: function(val){
        if (val == 200){
          this.$emit('successCreate');
        }
      },
    },
    created(){
      this.clearFields();
    },
    methods:{
      submitDataForm(){
        // un clear aquí?
        this.generateInvoice = true;
        this.form.step1.editable = false;
        this.form.step2.editable = false;
        let date = moment().format('YYYY-MM-DD');

        //para enviar
        let formSend = {
          data: {
            provider: this.form.step2.client,
            number: this.invoice_id,
            dueDate: '',
            invoiceDate: date,
            items: this.items,
            notes: this.invoice_notes,
          },
        };
        this.$store.dispatch('createPayout', formSend);
      },
      clearFields(){
        this.form.step1.invoiceClients.value = null;
        this.form.step2.client = '';
        this.invoice_id = '';
        this.items = [];
        this.invoice_notes = '';
      },
      onSubmitStep1(){
        this.form.stepVisible = 2;
        this.form.step2.editable = true;
      },
      onSubmitStep2(){
        this.form.stepVisible = 3;
        this.form.step3.editable = true;
      },
      clearSelect(){
        this.form.step2.client = '';
      },
      setInvoiceTo(){
        if(this.form.step1.invoiceClients.value == '1'){
          let provider = this.$store.state.providers.find(item =>{ return item._id == this.form.step2.client});
          let providerInvoice = provider.inv;
          this.clientName =  providerInvoice.n;
          this.client_address = providerInvoice.a;
          this.client_email = providerInvoice.m;
          this.client_phone = providerInvoice.p;
          this.client_vat = providerInvoice.v;
          this.tax = providerInvoice.t;
        }else{
          let operator = this.$store.state.operators.find(item =>{ return item._id == this.form.step2.client});
          let operatorInvoice = operator.inv;
          this.clientName =  operatorInvoice.n;
          this.client_address = operatorInvoice.a;
          this.client_email = operatorInvoice.m;
          this.client_phone = operatorInvoice.p;
          this.client_vat = operatorInvoice.v;
          this.tax = operatorInvoice.t;
        }
      },
      formatDate(date) {
        return moment(date).format('DD/MM/YYYY');
      },
      exportPDF() {
        var element = this.$refs.content;
        var opt = {
          margin:       0,
          filename:     'myfile.pdf',
          image:        { type: 'jpeg', quality: 1 },
          html2canvas:  { scale: 2 },
          jsPDF:        { unit: 'in', format: 'letter', orientation: 'portrait' },
        };
        html2pdf().set(opt).from(element).save();
      }
    },
  }
</script>

<style lang="sass">
  .invoice__table
    th
      border: 0
    tfoot
      td
        border-width: 1px 0 0
  .fade-enter
    opacity: 0
  .fade-enter-active
    transition: opacity 1s
  .fade-leave-active
    transition: opacity 1s
    opacity: 0
  .finance__paymentDetails__card__header
    background: rgba(128, 128, 128, 0.41)
    color: #000
  .finance__paymentDetails__card__details
    background-color: #F5F5F5!important
  .finance__invoice
    border:1px solid #82828263
</style>